import React, { forwardRef, ForwardRefRenderFunction, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { ILookupField , IChoiceField, IContact, IDestinatarioPecMail, IDestinatarioProtocollo, IField, ITextField } from '../../shared/interfaces';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import { mergeStyleSets, IMessageBarProps, IDropdownOption, ITag, MessageBarType, IBasePickerSuggestionsProps, ValidationState, IBasePickerProps, IPersonaProps } from '@fluentui/react';
import { RootState } from '../../store';
import { useSelector } from 'react-redux';
import DynamicForm from '../DynamicForm/DynamicForm';

import { useBoolean } from '@fluentui/react-hooks';
import { Contact_Type, Contact_Type_Label } from '../../shared/enums';
import indicePAService from '../../services/indicePA.service';
import Utilities from '../../shared/Utilities/utilities';
import AppUtilities from '../../shared/Utilities/appUtilities';
import contactsService from '../../services/contacts.service';
import abilityBuild from '../../shared/CASL/appAbility';
import { subject } from "@casl/ability";


const emailRegex = Utilities.GetRegexIndirizziEmailSeparatiDaPuntoEVirgola();

const classNames = mergeStyleSets({
    scrollablePaneWrapper: {
        position: 'relative',
        height: '100%',
    },

    inputWrapper:
    {
        paddingBottom: '20px',

    },
    compactCard: {
        alignItems: 'center',
        padding: "0 20px"
    },
    expandedCard: {
        padding: '16px 24px'
    },
    iconClass: {
        fontSize: 20,
        margin: '0 25px'
    },
    contactInfoGroup: {
        padding: '4px 0px',
    },

    address: {
        height: '20px'
    }

});


const tipologiaFied: IField =
    {
        displayName: "Tipologia",
        internalName: "tipologia",
        controlType: "dropdown",
        sharepointType: "Choice",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: Contact_Type.Undefined as Contact_Type,
        valid: false,
        touched: false,
        options: [
            { text: Contact_Type_Label.get(Contact_Type.PersonaFisica), key: Contact_Type.PersonaFisica },
            { text: Contact_Type_Label.get(Contact_Type.PersonaGiuridica), key: Contact_Type.PersonaGiuridica },
            { text: Contact_Type_Label.get(Contact_Type.Amministrazione), key: Contact_Type.Amministrazione },
            { text: Contact_Type_Label.get(Contact_Type.AmministrazioneEstera), key: Contact_Type.AmministrazioneEstera },
        ] as IDropdownOption[]
    } as IChoiceField;

const indicePAField: IField =
    {
        displayName: "Ricerca per denominazione o acronimo",
        internalName: "indicePA",
        sharepointType: "",
        controlType: "autocomplete",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: [],
        valid: false,
        touched: false,
        multi: false
    } as ILookupField ;

const rubricaField: IField =
    {
        displayName: "Ricerca un contatto della rubrica",
        internalName: "rubrica",
        list: "Rubrica", ///Utilizzando "Rubrica" capisco che devo puntare alla rubrica arxeia
        sharepointType: "",
        controlType: "autocompleteContact",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: [],
        valid: false,
        touched: false,
        multi: false,
    } as ILookupField ;

const indirizzoMailField: IField =
    {
        displayName: "Indirizzo PEC/Mail",
        internalName: "indirizzoMail",
        controlType: "autocomplete",
        sharepointType: "",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        valid: false,
        touched: false
    } as ILookupField ;

const nomeField: IField =
    {
        displayName: "Nome",
        internalName: "nome",
        controlType: "textbox",
        sharepointType: "Text",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        valid: false,
        touched: false,
    } as ITextField;

const cognomeField: IField =
    {
        displayName: "Cognome",
        internalName: "cognome",
        controlType: "textbox",
        sharepointType: "Text",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        valid: false,
        touched: false,
    } as ITextField;

const matricolaField: IField =

    {
        displayName: "Matricola",
        internalName: "matricola",
        controlType: "textbox",
        sharepointType: "Text",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        valid: false,
        touched: false
    } as ITextField;

const denominazioneField: IField =
    {
        displayName: "Denominazione",
        internalName: "denominazione",
        controlType: "textbox",
        sharepointType: "Text",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        valid: false,
        touched: false
    } as ITextField;

const codiceIPAField: IField =
    {
        displayName: "Codice IPA",
        internalName: "codiceIPA",
        controlType: "textbox",
        sharepointType: "Text",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        valid: false,
        touched: false
    } as ITextField


const initialFields: IField[] = [
    { ...tipologiaFied }
]

const personaFisicaFields: IField[] = [
    { ...nomeField },
    { ...cognomeField },
    { ...matricolaField }

];


const personaGiuridicaFields: IField[] = [
    { ...denominazioneField }
];

const amministrazioneFields: IField[] = [
    ...personaGiuridicaFields,
    { ...codiceIPAField }
];

export interface ContactFormProps {
    extraCssClass?: string
    showMessageError: (errorMessageProps: IMessageBarProps) => void
    dismissMessageError: () => void
    onContactFormChangedHandler: (destinatarioProtocollo: Partial<IDestinatarioProtocollo>) => void

}
export interface ContactFormHandle {
    checkFormValidity: () => boolean;
}
type Props = ContactFormProps




const ContactForm: ForwardRefRenderFunction<ContactFormHandle, Props> = (props, ref) => {
    useImperativeHandle(ref, () => ({
        checkFormValidity
    }));

    let [loading, { setTrue: showLoader, setFalse: hideLoader }] = useBoolean(false);

    let [contactFormFields, setContactFormFields] = useState<IField[]>([...initialFields]);

    // Crea un ref per tenere traccia dell'ultima versione di contactFormFields
    const contactFormFieldsRef = useRef(contactFormFields);

    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);


    const indirizzoMailSuggestionProps: IBasePickerSuggestionsProps = {
        suggestionsHeaderText: 'Suggerimenti',
        mostRecentlyUsedHeaderText: 'Indirizzi suggeriti',
        noResultsFoundText: 'Nessun risultato trovato',
        loadingText: 'Caricamento',
        showRemoveButtons: false,
        forceResolveText: "Aggiungi l'indirizzo digitato",
        showForceResolve: () => true

    };




    useEffect(() => {
        // Aggiorna il ref ogni volta che contactFormFields cambia
        contactFormFieldsRef.current = contactFormFields;

        let destinatarioProtocollo: Partial<IDestinatarioProtocollo> = {}

        let currentContactFormFields = [...contactFormFields];
        let itemIndex = currentContactFormFields.findIndex(el => el.internalName === rubricaField.internalName);
        if (itemIndex >= 0) {
            let currentfield = { ...currentContactFormFields[itemIndex] };
            destinatarioProtocollo.contactId = currentfield.internalValue ? currentfield.internalValue[0]?.key : undefined;
        }

        itemIndex = currentContactFormFields.findIndex(el => el.internalName === tipologiaFied.internalName);
        if (itemIndex >= 0) {
            let currentfield = { ...currentContactFormFields[itemIndex] };
            destinatarioProtocollo.tipologia = currentfield.internalValue;
        }

        itemIndex = currentContactFormFields.findIndex(el => el.internalName === nomeField.internalName);
        if (itemIndex >= 0) {
            let currentfield = { ...currentContactFormFields[itemIndex] };
            destinatarioProtocollo.nome = currentfield.internalValue;
        }

        itemIndex = currentContactFormFields.findIndex(el => el.internalName === cognomeField.internalName);
        if (itemIndex >= 0) {
            let currentfield = { ...currentContactFormFields[itemIndex] };
            destinatarioProtocollo.cognome = currentfield.internalValue;
        }

        itemIndex = currentContactFormFields.findIndex(el => el.internalName === denominazioneField.internalName);
        if (itemIndex >= 0) {
            let currentfield = { ...currentContactFormFields[itemIndex] };
            destinatarioProtocollo.denominazione = currentfield.internalValue;
        }

        itemIndex = currentContactFormFields.findIndex(el => el.internalName === matricolaField.internalName);
        if (itemIndex >= 0) {
            let currentfield = { ...currentContactFormFields[itemIndex] };
            destinatarioProtocollo.matricola = currentfield.internalValue;
        }

        itemIndex = currentContactFormFields.findIndex(el => el.internalName === codiceIPAField.internalName);
        if (itemIndex >= 0) {
            let currentfield = { ...currentContactFormFields[itemIndex] };
            destinatarioProtocollo.codiceIPA = currentfield.internalValue;
        }

        itemIndex = currentContactFormFields.findIndex(el => el.internalName === indirizzoMailField.internalName);
        if (itemIndex >= 0) {
            let currentfield = { ...currentContactFormFields[itemIndex] };
            destinatarioProtocollo.email = currentfield.internalValue ? currentfield.internalValue[0]?.key : undefined;
        }

        props.onContactFormChangedHandler(destinatarioProtocollo);

    }, [contactFormFields]);

    const searchIndicePASuggestions = async (filterText: string, currentTags?: ITag[]): Promise<ITag[]> => {
        let result: ITag[] = [];

        if (currentAoo && filterText) {
            await indicePAService.searchEntePA(currentAoo.id, filterText)
                .then(suggestions => {
                    result = suggestions.map(el => {
                        let tag: ITag = {
                            name: el.denominazione,
                            key: el.codiceIPA,
                        }
                        return tag;
                    });

                }, error => {

                    let errorMessageProps: IMessageBarProps = {
                        //truncated: true,
                        isMultiline: false,
                        overflowButtonAriaLabel: "See more",
                        dismissButtonAriaLabel: "Close",
                        messageBarType: MessageBarType.error,
                        children: `Errore nella ricerca dell'ente PA`,

                    };
                    props.showMessageError(errorMessageProps);

                });
        }

        if (currentTags) {
            //Rimuovo eventuali elementi già selezionati
            result = result.filter(tag => currentTags.findIndex(el => el.key === tag.key) < 0);
        }
        return result;

    }

    const filterContactsByText = async (filterText: string, currentTags?: IPersonaProps[]): Promise<IPersonaProps[]> => {
        let currentContactFormFields = [...contactFormFieldsRef.current];
        let itemIndex = currentContactFormFields.findIndex(el => el.internalName === tipologiaFied.internalName);
        let currentfield = { ...currentContactFormFields[itemIndex] };

        let contacts: any[] = [];
        if (currentAoo && filterText) {
            await contactsService.getContactSuggestions(currentAoo!.id, filterText.toLowerCase(), currentfield.internalValue)
                .then(suggestions => {
                    suggestions.forEach(contact => {
                        let secondaryText = contact.email1 ?? contact.email2 ?? "";
                        contacts.push(
                            {
                                key: contact.id,
                                imageInitials: contact.iniziali,
                                text: contact.contatto,
                                secondaryText: secondaryText,
                                showSecondaryText: true,
                                hidePersonaDetails: false,
                                contact
                            }
                        );
                    })
                });
        }

        if (currentTags) {
            //Rimuovo eventuali elementi già selezionati
            contacts = contacts.filter(tag => currentTags.findIndex(el => el.key === tag.key) < 0);
        }
        return contacts;

    };

    const onInputChangedHandler = (updatedField: IField) => {
        let updatedContactFields = [...(contactFormFieldsRef.current ?? [])];
        let itemIndex = updatedContactFields.findIndex(el => el.internalName === updatedField.internalName);
        updatedContactFields[itemIndex] = { ...updatedField };
        switch (updatedField.internalName) {

            case 'tipologia':
                onSelectTipologiaField(updatedField);
                break;

            case 'indicePA':
                onSelectIndicePAField(updatedContactFields, updatedField);
                break;

            case 'rubrica':
                onSelectRubricaField(updatedContactFields, updatedField);
                break;

            default:
                setContactFormFields([...updatedContactFields]);
                break;
        }
    }

    const onSelectTipologiaField = (updatedField: IField) => {
        let emailField = {
            ...indirizzoMailField,

            basePickerProps: {
                pickerSuggestionsProps: indirizzoMailSuggestionProps,
                onValidateInput: (input) => onValidateIndirizzoEmailPickerInput(indirizzoMailField.internalName, input),
                onResolveSuggestions: (searchValue: string): ITag[] => []
            }
        } as ILookupField ;


        // ridefinisco onResolveSuggestions ogni volta che cambia il tipo di contatto (per filtrare i suggerimenti in base al tipo)
        let updatedRubricaField = {
            ...rubricaField,
        } as ILookupField ;
        updatedRubricaField.basePickerProps = { onResolveSuggestions: filterContactsByText } as IBasePickerProps<IPersonaProps>;

        switch (updatedField.internalValue) {
            case Contact_Type.PersonaFisica:
                let newPersonaFisicaFields = [...personaFisicaFields];
                if (abilityBuild.can('use', subject('IFeature', { key: 'Segnatura', enabled: true }))) {
                    newPersonaFisicaFields.forEach(el => {
                        if (el.internalName !== 'matricola') {
                            el.required = true;
                        }
                    })
                }
                else {
                    newPersonaFisicaFields.forEach(el => el.required = false)
                }
                setContactFormFields([{ ...updatedField }, { ...updatedRubricaField }, ...newPersonaFisicaFields, { ...emailField }]);
                break;

            case Contact_Type.PersonaGiuridica:
            case Contact_Type.AmministrazioneEstera:
                let newPersonaGiuridicaFields = [...personaGiuridicaFields];
                if (abilityBuild.can('use', subject('IFeature', { key: 'Segnatura', enabled: true }))) {
                    newPersonaGiuridicaFields.forEach(el => el.required = true)
                }
                else {
                    newPersonaGiuridicaFields.forEach(el => el.required = false)
                }

                setContactFormFields([{ ...updatedField }, { ...updatedRubricaField }, ...newPersonaGiuridicaFields, { ...emailField }]);
                break;

            case Contact_Type.Amministrazione:
                let newAmministrazioneFields = [...amministrazioneFields];
                if (abilityBuild.can('use', subject('IFeature', { key: 'Segnatura', enabled: true }))) {
                    newAmministrazioneFields.forEach(el => el.required = true)
                }
                else {
                    newAmministrazioneFields.forEach(el => el.required = false)
                }


                let ipaField = {
                    ...indicePAField,
                } as ILookupField ;
                ipaField.basePickerProps = { onResolveSuggestions: searchIndicePASuggestions } as IBasePickerProps<ITag>;
                setContactFormFields([{ ...updatedField }, { ...updatedRubricaField }, { ...ipaField }, ...newAmministrazioneFields, { ...emailField }]);
                break;
        }
    }

    const onSelectIndicePAField = (updatedContactFields: IField[], updatedField: IField) => {
        let codiceIPA = updatedField.internalValue[0]?.key;
        if (currentAoo && codiceIPA) {
            showLoader();
            indicePAService.getEntePA(currentAoo.id, codiceIPA)
                .then(entePA => {

                    Object.keys(entePA).forEach(key => {
                        if (key === 'indirizziMail') {

                            let itemIndex = updatedContactFields.findIndex(el => el.internalName === indirizzoMailField.internalName);
                            if (itemIndex >= 0) {
                                let indirizziMailTagArray: ITag[] = [];

                                entePA.indirizziMail.forEach((el, index) => {
                                    indirizziMailTagArray.push({
                                        name: el,
                                        key: el,
                                    });
                                })

                                let newfield = { ...updatedContactFields[itemIndex] } as ILookupField ;

                                newfield.basePickerProps.onResolveSuggestions = async (searchValue: string, currentTags?: ITag[]): Promise<ITag[]> => {
                                    let result: ITag[] = indirizziMailTagArray.filter(el => el.key.toString().toLowerCase().includes(searchValue.toLowerCase()));
                                    if (currentTags) {
                                        //Rimuovo eventuali elementi già selezionati
                                        result = result.filter(persona => currentTags.findIndex(el => el.key === persona.key) < 0);
                                    }
                                    return result;
                                }
                                newfield.basePickerProps.onEmptyResolveSuggestions = () => [...indirizziMailTagArray]
                                updatedContactFields[itemIndex] = { ...newfield }
                            }

                        }
                        else {
                            let itemIndex = updatedContactFields.findIndex(el => el.internalName === key);
                            if (itemIndex >= 0) {
                                let newfield = { ...updatedContactFields[itemIndex] };
                                newfield.internalValue = entePA[key].toString();
                                updatedContactFields[itemIndex] = { ...newfield }
                            }
                        }
                    });
                    setContactFormFields([...updatedContactFields]);
                    hideLoader();
                }, error => {

                    let errorMessageProps: IMessageBarProps = {
                        //truncated: true,
                        isMultiline: false,
                        overflowButtonAriaLabel: "See more",
                        dismissButtonAriaLabel: "Close",
                        messageBarType: MessageBarType.error,
                        children: `Errore nella ricerca dell'ente PA`,

                    };
                    props.showMessageError(errorMessageProps);

                });
        }
    }

    const onSelectRubricaField = (updatedContactFields: IField[], updatedField: IField) => {
        let contact = updatedField.internalValue[0]?.contact as IContact;

        let itemIndex = updatedContactFields.findIndex(el => el.internalName === indirizzoMailField.internalName);
        if (itemIndex >= 0) {

            let indirizziMailTagArray: ITag[] = [];
            if (contact?.email1) {
                indirizziMailTagArray.push({
                    name: contact.email1,
                    key: contact.email1,
                });
            }
            if (contact?.email2) {
                indirizziMailTagArray.push({
                    name: contact.email2,
                    key: contact.email2,
                });
            }
            let newfield = { ...updatedContactFields[itemIndex] } as ILookupField ;

            newfield.basePickerProps.onResolveSuggestions = async (searchValue: string, currentTags?: ITag[]): Promise<ITag[]> => {
                let result: ITag[] = indirizziMailTagArray.filter(el => el.key.toString().toLowerCase().includes(searchValue.toLowerCase()));
                if (currentTags) {
                    //Rimuovo eventuali elementi già selezionati
                    result = result.filter(persona => currentTags.findIndex(el => el.key === persona.key) < 0);
                }
                return result;
            }
            newfield.basePickerProps.onEmptyResolveSuggestions = () => [...indirizziMailTagArray]

            if (indirizziMailTagArray.length === 0) {
                newfield.internalValue = []
            }
            else if (indirizziMailTagArray.length === 1) {
                newfield.internalValue = [indirizziMailTagArray[0]]
            }
            updatedContactFields[itemIndex] = { ...newfield }
        }

        itemIndex = updatedContactFields.findIndex(el => el.internalName === nomeField.internalName);
        if (itemIndex >= 0) {

            let newfield = { ...updatedContactFields[itemIndex] };
            newfield.internalValue = contact?.nome;
            updatedContactFields[itemIndex] = { ...newfield }
        };
        itemIndex = updatedContactFields.findIndex(el => el.internalName === cognomeField.internalName);
        if (itemIndex >= 0) {

            let newfield = { ...updatedContactFields[itemIndex] };
            newfield.internalValue = contact?.cognome;
            updatedContactFields[itemIndex] = { ...newfield }
        };
        itemIndex = updatedContactFields.findIndex(el => el.internalName === denominazioneField.internalName);
        if (itemIndex >= 0) {

            let newfield = { ...updatedContactFields[itemIndex] };
            newfield.internalValue = contact?.denominazione;
            updatedContactFields[itemIndex] = { ...newfield }
        };
        itemIndex = updatedContactFields.findIndex(el => el.internalName === matricolaField.internalName);
        if (itemIndex >= 0) {

            let newfield = { ...updatedContactFields[itemIndex] };
            newfield.internalValue = contact?.matricola;
            updatedContactFields[itemIndex] = { ...newfield }
        };
        itemIndex = updatedContactFields.findIndex(el => el.internalName === codiceIPAField.internalName);
        if (itemIndex >= 0) {

            let newfield = { ...updatedContactFields[itemIndex] };
            newfield.internalValue = contact?.codiceIPA;
            updatedContactFields[itemIndex] = { ...newfield }
        };

        setContactFormFields([...updatedContactFields]);
        hideLoader();
    }


    const onValidateIndirizzoEmailPickerInput = (fieldInternalName: string, input: string) => {
        if (input && emailRegex.test(input)) {
            return ValidationState.valid;
        }
        else {
            let currentContactFormFields = [...(contactFormFieldsRef.current ?? [])];
            let itemIndex = currentContactFormFields.findIndex(el => el.internalName === fieldInternalName);
            if (itemIndex > 0) {
                let newField = { ...currentContactFormFields[itemIndex] };
                newField.valid = false;
                newField.touched = true;
                onInputChangedHandler(newField);

            }
            return ValidationState.invalid
        }

    }

    const checkFormValidity = (): boolean => {
        let isValid = true;


        let updatedContactFields = [...(contactFormFieldsRef.current ?? [])];

        Object.values(updatedContactFields).forEach((field: IField, index) => {
            let newField = { ...field };
            let fieldValidity = AppUtilities.checkFieldValidity(newField)
            if (!fieldValidity) {
                isValid = false;
            }
            let itemIndex = updatedContactFields.findIndex(el => el.internalName === newField.internalName);
            if (itemIndex >= 0) {
                updatedContactFields[itemIndex] = {
                    ...newField,
                    touched: true,
                    valid: fieldValidity
                }

            }
        });

        setContactFormFields([...updatedContactFields]);

        if (isValid)
            props.dismissMessageError()
        else {
            let errorMessageProps: IMessageBarProps = {
                //truncated: true,
                isMultiline: false,
                overflowButtonAriaLabel: "See more",
                dismissButtonAriaLabel: "Close",
                messageBarType: MessageBarType.error,
                children: `Compilare correttamente tutti i campi obbligatori`,

            };

            props.showMessageError(errorMessageProps);

        }
        return isValid;
    }
    return (
        <React.Fragment >

            <CircleLoader loaderClass='loader-large' loading={loading} />

            <div className={"flex flex-column position-relative overflow-hidden"}>

                <div className={`position-relative my-scroll-div`}>
                    <DynamicForm
                        fields={contactFormFields}
                        onInputChangedHandler={(updatedField) => { onInputChangedHandler(updatedField) }}
                    />

                </div>

            </div>

        </React.Fragment>
    );
};


const ForwardedContactForm = React.forwardRef(ContactForm);
export default ForwardedContactForm;




